import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { readJson, writeJson } from './storage';

const CART_KEY = 'hr-shop:cart';
const CartContext = createContext(null);

/** Handlekurv for fastprisprodukter: slug + mengde i tonn. Lagres i localStorage. */
export function CartProvider({ children }) {
  const [items, setItems] = useState(() => readJson(window.localStorage, CART_KEY, []));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    writeJson(window.localStorage, CART_KEY, items);
  }, [items]);

  const add = useCallback((slug, quantityTonnes) => {
    const q = Math.max(0.5, Number(quantityTonnes) || 0);
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.slug === slug);
      if (idx === -1) return [...prev, { slug, quantityTonnes: q }];
      const next = [...prev];
      next[idx] = { ...next[idx], quantityTonnes: Math.round((next[idx].quantityTonnes + q) * 10) / 10 };
      return next;
    });
  }, []);

  const setQuantity = useCallback((slug, quantityTonnes) => {
    const q = Number(quantityTonnes);
    setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, quantityTonnes: Number.isFinite(q) ? q : i.quantityTonnes } : i)));
  }, []);

  const remove = useCallback((slug) => setItems((prev) => prev.filter((i) => i.slug !== slug)), []);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => ({ items, count: items.length, add, setQuantity, remove, clear, open, setOpen }), [items, add, setQuantity, remove, clear, open]);
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart utenfor CartProvider');
  return ctx;
}
